import React, { useState } from "react";
import SFDropdown from "../dropdown";
import { SFExpandMoreIcon, SFExpandLessIcon } from "../icons";
import PropTypes from "prop-types";
import CustomButton from "./customButton";

const SFDropdownButton = ({
  items,
  label,
  variant,
  className,
  sx,
  disabled,
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClickDropdown = (e) => {
    setAnchorEl(e.currentTarget);
    setOpen((prev) => !prev);
  };
  const handleCloseDropdown = () => {
    setOpen(false);
  };

  return (
    <SFDropdown
      items={items}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      trigger={
        <CustomButton
          disabled={disabled}
          className={className}
          onClick={handleClickDropdown}
          sx={sx}
          variant={variant}
          endIcon={open ? <SFExpandLessIcon /> : <SFExpandMoreIcon />}
        >
          {label}
        </CustomButton>
      }
      open={open}
      anchorEl={anchorEl}
      onClose={handleCloseDropdown}
    />
  );
};

SFDropdownButton.propTypes = {
  sx: PropTypes.object,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
};

SFDropdownButton.defaultProps = {
  disabled: false,
};

export default SFDropdownButton;
